/**
 * Critical-resource preloader — runs at module evaluation, before
 * React rendering begins. Pushes high-priority preload hints into
 * <head> so the browser starts fetching the LCP hero images and the
 * intro popup video on the very first parse pass.
 *
 * Visual / layout / animation footprint: ZERO.
 * It only affects when bytes hit the network — no DOM rendering.
 */

const ARACELY_URL = '/img/aracely-2026-07.webp';
const AMY_URL = '/img/df2ou4wz_HE2A5111copy.webp';
const LOGO_URL = '/logo.png';

const inject = (rel, href, opts = {}) => {
  try {
    const l = document.createElement('link');
    l.rel = rel;
    l.href = href;
    if (opts.as) l.as = opts.as;
    if (opts.type) l.type = opts.type;
    if (opts.fetchPriority) l.setAttribute('fetchpriority', opts.fetchPriority);
    if (opts.crossOrigin !== undefined) l.crossOrigin = opts.crossOrigin;
    document.head.appendChild(l);
  } catch (_) { /* noop */ }
};

if (typeof document !== 'undefined') {
  // High-priority preloads for above-the-fold images that drive LCP.
  // The browser will deduplicate when the actual <img> renders.
  inject('preload', LOGO_URL, { as: 'image', fetchPriority: 'high' });
  inject('preload', ARACELY_URL, { as: 'image', fetchPriority: 'high' });
  inject('preload', AMY_URL, { as: 'image', fetchPriority: 'high' });

  // Preconnect to YouTube's domains — the bottom-page Short embed needs
  // these 4 hosts to start streaming. Doing the DNS + TLS handshake during
  // initial page paint means the video is ready to play near-instantly the
  // moment the user scrolls down (saves 200-400ms on cold visits).
  ['https://www.youtube.com', 'https://www.google.com', 'https://i.ytimg.com', 'https://yt3.ggpht.com'].forEach((host) => {
    inject('preconnect', host, { crossOrigin: 'anonymous' });
    inject('dns-prefetch', host);
  });
}

export {};
